(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('BreakdownController', breakdown);

  breakdown.$inject = ['$scope', '$http', 'FoundationApi', 'StatusService', 'NotificationFactory', 'BreakdownService'];

  function breakdown ($scope, $http, FoundationApi, StatusService, NotificationFactory, BreakdownService) {
    var vm = this;

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    vm.breakdowns = [];

    var affected_triggers = [];

    BreakdownService.all()
      .success(function (breakdowns) {
        breakdowns.map(function (breakdown) {
          breakdown.texts = [];
          breakdown.overlap = false;

          angular.forEach(breakdown.data, function (data) {
            if (breakdown.is_active) {
              if (!jQuery.inArray(data.replace_trigger_id, affected_triggers)) {
                affected_triggers.push(data.replace_trigger_id);
              } else {
                breakdown.overlap = true;
              }
            }
            angular.forEach(data.actions_on, function (action) {
              if (action.type == 'TEXT') {
                action.name = data.trigger.name;
                breakdown.texts.push(action);
              }
            });
          });

          return breakdown;
        });
        vm.breakdowns = breakdowns;
      });

    vm.confirmBreakdown = confirmBreakdown;
    vm.switchBreakdown = switchBreakdown;
    vm.breakdown = null;

    function confirmBreakdown (breakdown, switch_to) {
      if (breakdown.is_active != switch_to) {
        vm.breakdown = breakdown;
        vm.switch_to = switch_to;
        vm.action = (switch_to == 1) ? 'ativar' : 'desativar';
        FoundationApi.publish('dlgConfirmSwitch', 'open');
      }
    }
    function switchBreakdown () {
      vm.breakdown.is_active = vm.switch_to;
      FoundationApi.publish('dlgConfirmSwitch', 'close');

      BreakdownService.activate({ id: vm.breakdown.id },
        	{
            		type: vm.switch_to,
            		texts: vm.breakdown.texts
        	})
        .success(function () {
          notifSet.addNotification({
            title: 'Sucesso!',
            content: $scope.labels.sucAlterBreakdown,
            color: 'success',
            autoclose: 3000
          });
        });
    }
  }
})();
